import React, { useState } from "react";
import Header from '../components/Header'; // Retaining Header
import '../pages/Home.css'; // Keep your existing CSS
import '../pages/SignIn.css'; // Import the SignIn-specific CSS
const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // Add sign-in logic here
    console.log("Signed in with:", { email, password });
  };

  return (
    <div className="home-container" style={{ position: 'relative', overflow: 'hidden' }}>
      <Header /> {/* Retaining the Header from Home */}

      {/* Sign-In Form Section */}
      <div className="form-container">
        <h1>Sign In</h1> {/* Title for Sign In */}
        <p>Access your account and enjoy the event!</p>
        <form onSubmit={handleSubmit} className="form">
          <div className="input-group">
            <label htmlFor="email" className="label">
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input"
              required
            />
          </div>
          <div className="input-group">
            <label htmlFor="password" className="label">
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input"
              required
            />
          </div>
          <button type="submit" className="button">Sign In</button>
        </form>
      </div>
    </div>
  );
};

export default SignIn;
